import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, TemplateRef, Injectable } from '@angular/core';
import { MzBaseModal, MzModalComponent } from 'ngx-materialize';
import { instituciones } from 'src/app/_models/instituciones.model';
import { procesadores } from 'src/app/_models/formularios/procesadores.model';
import { ZeroService } from '../../_services/zero/zero.service';
import { REST_SERVICES } from '../../_services/settings';
declare var $: any;
/*:
 * Modal para actualizacion de instituciones
 * 
 * By: fruiz
 */
@Component({ templateUrl: './modaleditIns.component.html' })

@Injectable()
export class ModalsComponentInsEdit extends MzBaseModal {
  public institucionesEdit: instituciones;
  public procIns: instituciones;
  public procesador: procesadores;
  public institucion: instituciones;
  public instituciones: Array<instituciones>;
  public procesadores: Array<procesadores>;
  //Parametros de ID Compuesto
  public idProcEdit: string;
  public idInsEdit: string;
  public tipoInsEdit: string;
  public idbmInsEdit: string;
  public idEntidadInsEdit: string;
  public IDINSTITUCIONEDIT: string;
  //Variables que provienen de los campos
  @ViewChild('IDIns') IDIns: ElementRef;
  @ViewChild('DSCIns') DSCIns: ElementRef;
  @ViewChild('WarningIns') WarningIns: MzModalComponent;  
  @ViewChild('ErrorEditIns') ErrorEditIns: MzModalComponent;
  @ViewChild('flag1Edit') flag1Edit: ElementRef;
  @ViewChild('flag2Edit') flag2Edit: ElementRef;
  @ViewChild('idbm') idbm: ElementRef;
  @ViewChild('idbo') idbo: ElementRef;
  @ViewChild('idBco') idBco: ElementRef;
  @ViewChild('idEntidadEdit') idEntidadEdit: ElementRef;
  // datos de entrada por el servicio de modal
  @Input() public institucionEdit: instituciones;

  // Emitter para envío de parámetros
  @Output() updateIns: EventEmitter<instituciones>;

  public modalOptions: Materialize.ModalOptions = {
    dismissible: false,
    opacity: .5,
    inDuration: 300,
    outDuration: 200,
    startingTop: '100%',
    endingTop: '10%',
  };

  constructor(private zeroService: ZeroService) {
    super();
    this.updateIns = new EventEmitter();
    this.institucionesEdit = new instituciones();
    this.procIns = new instituciones();
    this.procesador = new procesadores();
    this.institucion = new instituciones();
    this.procesadores = new Array<procesadores>();
    this.instituciones = new Array<instituciones>();
  }

  ngOnInit() {
    this.institucionesEdit.idAnt = this.institucionEdit.id;
    this.institucionesEdit.entidadID = this.lpad(String(this.institucionEdit.entidad_id),4);
    this.insertInstituciones();
    this.insertProcesadores();
    this.setIDCompuestoOnInit(this.institucionEdit);
  }

  setIDCompuestoOnInit(institucion: instituciones) {     
    this.institucionesEdit.dsc = institucion.dsc;
    this.institucionesEdit.idInstitucionPk = institucion.idInstitucionPk;
    if(institucion.id >= 10000) {
      this.idProcEdit = institucion.id.toString().substring(0,1);
      this.tipoInsEdit = institucion.id.toString().substring(1,2);
      this.idEntidadInsEdit = institucion.id.toString().substring(2,6);
      this.IDINSTITUCIONEDIT = this.idProcEdit+this.tipoInsEdit+this.idEntidadInsEdit;
    } else {
      this.IDINSTITUCIONEDIT = institucion.id.toString();
    }    
    this.institucionesEdit.idBm = institucion.idBm;
    this.institucionesEdit.idBo = institucion.idBo;
    this.institucionesEdit.idBco = institucion.idBco;
    this.institucionesEdit.id = Number(this.IDINSTITUCIONEDIT);
    this.institucionesEdit.flgAdquirente = institucion.flgAdquirente;
    this.institucionesEdit.flgEmisor = institucion.flgEmisor;
    this.institucionesEdit.flgCamara = institucion.flgCamara;
    this.institucionesEdit.flgAgregadorTecnologico = institucion.flgAgregadorTecnologico;
    this.institucionesEdit.flgAutPorAgregador = institucion.flgAutPorAgregador;
    this.institucionesEdit.flgSoporteCash = institucion.flgSoporteCash;
    this.institucionesEdit.flgCashCredito = institucion.flgCashCredito;
    this.institucionesEdit.idProcesadorFk = Number(institucion.idProcesadorFk);
    this.institucionesEdit.idAgregador = institucion.idAgregador != null ? Number(institucion.idAgregador) : null;
    this.institucionesEdit.flgActiva = institucion.flgActiva;
    this.institucionesEdit.cardFiCred = institucion.cardFiCred;
    this.institucionesEdit.cardFiDeb = institucion.cardFiDeb;
    this.institucionesEdit.prefBin = institucion.prefBin;
    this.institucionesEdit.razonSocial = institucion.razonSocial;
    this.institucionesEdit.entidad_id = institucion.entidad_id;
	this.institucionesEdit.multired = institucion.multired;
	this.institucionesEdit.idBancoAtm = institucion.idBancoAtm;
  }

  cancelar() {
    this.modalComponent.closeModal();
    this.WarningIns.closeModal();
  }

  insertInstituciones() {
    let scope = this;
    this.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.CATALOGO_INSTITUCIONES.replace("%id","0"),
      method: "GET",
      showInfo: true,
      ok: (response) => {
        scope.instituciones = response.response;
      }
    });
  }

  insertProcesadores() {
    let scope = this;
    this.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.CATALOGO_PROCESADORES,
      method: "GET",
      showInfo: true,
      ok: (response) => {
        scope.procesadores = response.response;
      }
    });
  }



  setEditTipoInstitucion(tipo: string) {
    this.tipoInsEdit = tipo;
    if (Number(tipo) == 1){
      this.institucionesEdit.flgAdquirente = false;
      this.institucionesEdit.flgEmisor = true;
    } else {
      this.institucionesEdit.flgAdquirente = true;
      this.institucionesEdit.flgEmisor = false;
    }
    this.llenarDatosIDcompuestoEdit();
  }

  lpad(num:string, size:number): string {
      let s = num+"";
      while (s.length < size) s = "0" + s;
      return num.trim().length > 0 ?s:"";
  }

  setEditIdBM() {
    this.idbmInsEdit = this.lpad(this.idbm.nativeElement.value, 4);
  }

  setEditIdEntidad() {
    this.idEntidadInsEdit = this.lpad(this.idEntidadEdit.nativeElement.value, 4);
    this.llenarDatosIDcompuestoEdit();
  }

  setEditProcesador(idProc: string) {
    this.idProcEdit = idProc;
    this.llenarDatosIDcompuestoEdit();
  }

  setEditAgregador(idInst: string) {
    this.idInsEdit = idInst;
    this.llenarDatosIDcompuestoEdit();
  }


  //Métodos para alta de nueva institucion
  llenarDatosIDcompuestoEdit() {
    this.IDINSTITUCIONEDIT = null;
    this.IDINSTITUCIONEDIT = (this.idProcEdit != null ? this.idProcEdit : "") +
      (this.tipoInsEdit != null ? this.tipoInsEdit : "") +
      (this.idEntidadInsEdit != null ? this.idEntidadInsEdit : "");
      this.institucionesEdit.id = Number(this.IDINSTITUCIONEDIT);
  }
  // Aceptando el modal 
  public closeModal() {
    this.institucionesEdit.dsc = this.DSCIns.nativeElement.value;
    this.institucionesEdit.dsc = this.institucionesEdit.dsc.trim();
    if ((this.institucionesEdit.flgAdquirente == false && this.institucionesEdit.flgEmisor == false) ||
      this.institucionesEdit.idInstitucionPk == null ||
      this.institucionesEdit.dsc == null ||
      this.institucionesEdit.idProcesadorFk == null ||
      this.institucionesEdit.idBm == null ||
      this.institucionesEdit.idBm.trim().length == 0 ||
      this.institucionesEdit.dsc.trim().length == 0 ||
      this.institucionesEdit.idInstitucionPk.toString().trim().length == 0 ||
      this.institucionesEdit.idBco == null ||
      this.institucionesEdit.idBco.trim().length == 0 ||
      this.institucionesEdit.entidadID == null ||
      String(this.institucionesEdit.entidadID).trim().length == 0) {
      this.ErrorEditIns.openModal();
    } else {
      this.institucionesEdit.entidad_id = Number(this.institucionesEdit.entidadID);
      if (this.institucionesEdit.idAnt != this.institucionesEdit.id) {
        this.WarningIns.openModal();
      } else {
        this.updateIns.emit(this.institucionesEdit);
        this.modalComponent.closeModal();
      }
    }
  }

  public closeModalwarning() {    
    this.institucionesEdit.dsc = this.DSCIns.nativeElement.value;
    this.institucionesEdit.dsc = this.institucionesEdit.dsc.trim();
    this.updateIns.emit(this.institucionesEdit);
    this.IDINSTITUCIONEDIT = null;
    this.idProcEdit = null;
    this.tipoInsEdit = null;
    this.idbmInsEdit = null;
    this.institucionesEdit.idBco = "";
    this.cancelar();
  }

  limpiarAgregador(valor: boolean) {
    if (!valor) {
      this.institucionesEdit.idAgregador = null;
    }
  }
}
